import React, { useMemo } from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import styled from "styled-components";
import { KeywordResponse } from "../types";

const ChartContainer = styled.div`
  width: 100%;
  height: 400px;
  margin-top: 40px;
  padding: 24px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
`;

const ChartTitle = styled.h3`
  font-size: 16px;
  font-weight: 600;
  color: #1a202c;
  margin-bottom: 20px;
`;

interface KeywordsChartProps {
  keywords: KeywordResponse[];
}

export const KeywordsChart: React.FC<KeywordsChartProps> = ({ keywords }) => {
  const chartData = useMemo(() => {
    if (!keywords || keywords.length === 0) return [];

    return keywords
      .filter(kw => kw.currentRanking > 0)
      .slice(0, 20)
      .map(kw => ({
        keyword: kw.title.length > 20 ? kw.title.slice(0, 20) + "…" : kw.title,
        posição: kw.currentRanking,
      }));
  }, [keywords]);

  if (!keywords || keywords.length === 0) {
    return null;
  }

  return (
    <ChartContainer>
      <ChartTitle>Posição Atual das Palavras-Chave</ChartTitle>
      <ResponsiveContainer width="100%" height="100%">
        <LineChart data={chartData}>
          <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" />
          <XAxis
            dataKey="keyword"
            stroke="#718096"
            style={{ fontSize: "11px" }}
            interval={0}
            angle={-30}
            textAnchor="end"
            height={60}
          />
          <YAxis
            stroke="#718096"
            style={{ fontSize: "12px" }}
            reversed
          />
          <Tooltip
            contentStyle={{
              backgroundColor: "#fff",
              border: "1px solid #e2e8f0",
              borderRadius: "6px",
              boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
            }}
            formatter={(value) => [value, "Posição"]}
            labelStyle={{ color: "#2d3748" }}
          />
          <Legend
            wrapperStyle={{ paddingTop: "20px" }}
            iconType="line"
          />
          <Line
            type="monotone"
            dataKey="posição"
            stroke="#10b981"
            dot={{ fill: "#10b981", r: 4 }}
            activeDot={{ r: 6 }}
            strokeWidth={2}
            name="Posição"
            isAnimationActive={true}
          />
        </LineChart>
      </ResponsiveContainer>
    </ChartContainer>
  );
};
